"use client"

import { Clipboard } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ClipboardIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ClipboardIcon = component(Icon)({ as: Clipboard })
